export const radiusRegex = /\bradius-[a-z]+\b/g;

export const spacingRegex = /\bspacing-[a-z]+\b/g;
